import React, { useEffect, useState } from "react";
import { Col, Row, Card, Button } from "@themesberg/react-bootstrap";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getReminder } from "../../app/api";
import Loader from "../../components/Loader";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import moment from 'moment'
export default () => {
  const { id } = useParams();
  const history = useHistory();

  const [frequency, setFrequency] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescritpion] = useState("");
  const [date, setDate] = useState("");
  const [reminder, setReminder] = useState(false);
  const [vendorId, setVendorID] = useState("");
  const [username, setUsername] = useState("");

  const [loading, setLoading] = useState(false);
  const [createdAt, setCreatedAt] = useState("");
  const fetchSingleAssets = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getReminder(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setFrequency(response.data?.data?.frequency);
      setTitle(response.data?.data?.title);
      setDescritpion(response.data?.data?.description);
      setDate(response.data?.data?.due_date);
      setReminder(response.data?.data?.email_reminder);
      setVendorID(response.data?.data?.vendor_name);
      setUsername(response.data?.data?.user_name);

      setCreatedAt(response.data?.data?.created_at);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleAssets();
  }, [id]);
  const handleBackClick = () => {
    history.push(Routes.Reminder.path);
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              <h4 className="mb-0">Reminder Details</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleBackClick}
              className=" me-2"
            >
              <span>Back</span>
            </Button>
          </div>

       
          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                 
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Row>
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Title:</p>{" "}
                                                            <p className="vendor-detail">{title}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Vendor:</p>
                                                            <p className="vendor-detail">{vendorId}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">User:</p>
                                                            <p className="vendor-detail">{username}</p>{" "}
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Due Date:</p>{" "}
                                                            <p className="vendor-detail">{moment(date).format("MM/DD/YYYY HH:mm")}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Description:</p>
                                                            <p className="vendor-detail">{description}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Reminder Email:</p>
                                                            <p className="vendor-detail">{reminder}</p>{" "}
                                                          </Col>
                                                        </Row>
                                                        <Row>
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Created Date:</p>{" "}
                                                            <p className="vendor-detail">{moment(createdAt).format("MM/DD/YYYY")}</p>{" "}
                                                          </Col>
                                    
                                                          <Col xs={12} sm={6} xl={4} lg={4}>
                                                            <p className="vendor-title">Frequency:</p>
                                                            <p className="vendor-detail">{frequency}</p>{" "}
                                                          </Col>
                                    
                                                          
                                                        </Row>

                    <Row>
                      <div className="vendor-Cont">
                        <Col xs={5} sm={5} xl={3} lg={3}>
                          <p className="vendor-title"></p>
                        </Col>
                        <Col xs={7} sm={7} xl={9} lg={9}>
                          {" "}
                          <p className="vendor-title">{}</p>{" "}
                        </Col>
                      </div>
                    </Row>

                    <Row>
                      <div className="vendor-Cont">
                        <Col xs={5} sm={5} xl={3} lg={3}>
                          <p className="vendor-title"> </p>
                        </Col>
                        <Col xs={7} sm={7} xl={9} lg={9}>
                          {" "}
                          <p className="vendor-title">{}</p>{" "}
                        </Col>
                      </div>
                    </Row>
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};
